import { useRef } from "react";
function SpanToast({ text }) {

    const spanRef = useRef(null);

    const selectText = () => {
        navigator.clipboard.writeText(text)
        const span = spanRef.current;
        if (!span) {
            return;
        }

        const range = document.createRange();
        range.selectNodeContents(span);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
    };
    
    return (
        <span ref={spanRef} onClick={selectText} style={{fontWeight : 600, cursor : 'pointer'}}>
          {text}
        </span>
    );
}

export default SpanToast